import React from "react";

const FeatherBoldNeueIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.19995 13.7999L10.6 5.3999",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.34908 12.2002H3.80005V10.6512C3.80005 8.9538 4.47433 7.32588 5.67457 6.12568L7.72557 4.07472C8.92573 2.87448 10.5536 2.2002 12.251 2.2002H13.8V3.74923C13.8 5.44661 13.1257 7.07452 11.9256 8.27468L9.87453 10.3257C8.67437 11.5259 7.04645 12.2002 5.34908 12.2002Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(FeatherBoldNeueIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;